export const environment = {
  production: false,
  serverUrl: 'https://vbqa1-api.dnvsspl.com/v1/',
  imageUrl: 'https://vbqa1-api.dnvsspl.com/v1/',
  pdfUrl: 'https://vbqa1-api.dnvsspl.com/v1/',

};
